import React, { useState } from "react";
import { Box, Modal, Typography, TextField, Button } from "@material-ui/core";
import { CheckCircle,Cancel } from "@material-ui/icons"; // Confirmation Icon
import { formIoData } from "../consts";
import Image from "../images/logo.png";
import "formiojs/dist/formio.full.css";
import { callEndpoint } from "../ApiCall";
import { FormBuilder as FormBuilderIo } from "react-formio";
import Footer from "../inc/footer";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%", // Use a percentage to make it responsive
  maxWidth: "400px", // Limit max width
  maxHeight: "80vh", // Limit max height to 80% of viewport height
  overflowY: "auto", // Add scrolling when content exceeds max height
  backgroundColor: "#fff",
  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
  padding: "20px",
  borderRadius: "8px",
  textAlign: "center",
};

const Create = () => {
  const [formData, setFormData] = useState(formIoData); // Manage form data state
  const [formName, setFormName] = useState(""); // Manage form name
  const [modalOpen, setModalOpen] = useState(false); // Manage modal visibility
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false); // Confirmation modal
  const [alertModalOpen, setAlertModalOpen] = useState(false); // Alert modal for empty form
  const [formId, setFormId] = useState(0); // Manage form name
  

  const handleSaveClick = () => {
    if (!formData || !formData.components || (formData.components.length === 1 && formData.components[0].action === 'submit')) {
      setAlertModalOpen(true); // Show alert modal
    } else {
      setModalOpen(true); // Open form name modal
    }
  };

  const saveResult = () => {
    if (!formData || !formData.components) {
      console.error("No form data available to save.");
      return;
    }

    const body = {
      name: formName.trim(),
      data: formData.components,
    };

    const endpoint = "formRoute.php";
    const action = "insertBuilderForm";

    // Simulate API call
    callEndpoint(body, endpoint, action)
        .then((response) => {
          setFormId(response.data);
          console.log("Form saved successfully");
        })
        .catch((err) => {
          console.error("Error saving form:", err);
          alert("Failed to save the form. Please try again.");
        });

    setModalOpen(false); // Close input modal
    setConfirmationModalOpen(true); // Open confirmation modal
  };

  const copyToClipboard = () => {
    const confirmationText = formId;
    navigator.clipboard.writeText(confirmationText);
    alert("Copied to clipboard!");
  };

  return (
    <div className="app-container">
      {/* Logo at the top */}
      <div>
        <img className="topCenter" src={Image} alt="logo" />
      </div>

      {/* Form Builder */}
      <div>
        <FormBuilderIo 
          form={formIoData}
          onChange={(schema) => setFormData(schema)} // Update state when the form changes
          saveForm={(data) => setFormData(data)} // Save form data when Save Form button is clicked
          saveText="Save Form"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSaveClick}
          style={{ marginTop: "20px" }}
        >
          Save Form
        </Button>
      </div>
      <Footer />

      {/* Modal for form name input */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
  <Box style={modalStyle}>
    <Typography variant="h6" component="h2" gutterBottom>
      Enter Form Name
    </Typography>
    <TextField
      fullWidth
      variant="outlined"
      label="Form Name"
      value={formName}
      onChange={(e) => setFormName(e.target.value)}
      style={{ marginBottom: "20px" }}
      error={!formName.trim()} // Highlight field in red if empty
      // helperText={!formName.trim() ? "Form name is required" : ""} // Show error message
    />
    <Button
      variant="contained"
      color="primary"
      onClick={saveResult}
      fullWidth
      disabled={!formName.trim()} // Disable button if formName is empty
    >
      Save
    </Button>
  </Box>
</Modal>

      {/* Confirmation Modal */}
      <Modal
        open={confirmationModalOpen}
        onClose={() => setConfirmationModalOpen(false)}
      >
        <Box style={modalStyle}>
          <CheckCircle
            style={{ fontSize: "50px", color: "green", marginBottom: "20px" }}
          />
          <Typography variant="h6" component="h2" gutterBottom>
            Form Saved Successfully!
          </Typography>
          <Typography variant="body1" gutterBottom>
            Form "{formName}" has been saved.
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            onClick={copyToClipboard}
            fullWidth
          >
            Copy
          </Button>
        </Box>
      </Modal>

      {/* Alert Modal for Empty Form */}
      <Modal open={alertModalOpen} onClose={() => setAlertModalOpen(false)}>
        <Box style={modalStyle}>
        <Cancel
            style={{ fontSize: "50px", color: "red", marginBottom: "20px" }}
          />
          <Typography variant="h6" component="h2" gutterBottom>
            Form Should Not Be Empty
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setAlertModalOpen(false)}
            fullWidth
          >
            OK
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default Create;
